import { Grid, Typography } from "@mui/material";
import { NumberFormatInput } from "components/FormControls/NumberFormatInput";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { SelectInput } from "components/FormControls/Select/Select";
import { limitsOptions } from "components/Layout/Campaign/utils/utils";
import { useMessage } from "hooks/intl";
import { SelectedLimitType } from "types/campaigns";
import { useStyles } from "../../AchievementForm.styles";

interface Props {
  limit: SelectedLimitType;
  errors?: any;

  setFieldValue: (field: string, value: any) => void;
}

export const LimitsSection = ({ limit, errors, setFieldValue }: Props) => {
  const { message } = useMessage();
  const classes = useStyles();
  const { type } = limit.interval;

  return (
    <>
      <Typography fontWeight={500} mt={8}>
        {message({ id: "achievementLimits" })}
      </Typography>
      <Typography className={classes.descriptionNote}>
        {message({ id: "achievementLimitsInfo" })}
      </Typography>
      <Grid container spacing={10}>
        <Grid xs={type === "noLimit" ? 12 : 6} item>
          <SelectInput
            width="100%"
            data-test-id="limit-type"
            items={limitsOptions.map((option) => ({
              id: option.value,
              label: message({ id: option.label }),
            }))}
            label={<RequiredFieldLabel text={message({ id: "timeframe" })} />}
            name="limit.interval.type"
            onChange={(event) => {
              event.target.value === "noLimit"
                ? setFieldValue("limit", { interval: { type: "noLimit" } })
                : setFieldValue("limit.interval.type", event.target.value);
            }}
          />
        </Grid>
        {type && type !== "noLimit" && (
          <Grid xs={6} item>
            <NumberFormatInput
              data-test-id="limit-value"
              label={
                <RequiredFieldLabel text={message({ id: "number/value" })} />
              }
              name="limit.value"
              error={errors?.limit?.value}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
};
